import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';

export const SvgTicketDimension = {
  height: 23,
  width: 20,
  viewBox: '0 0 20 23',
};

type SvgTicketProps = SVGProps<SVGSVGElement> & {
  ticketType?: 'both' | 'red' | 'yellow';
};

export const SvgTicket = memo(({ ticketType = 'both', ...props }: SvgTicketProps) => (
  <svg width={20} height={23} viewBox="0 0 20 23" fill="none" {...props}>
    <g filter="url(#ticketShadow)">
      {ticketType === 'both' && (
        <>
          {/* Back yellow ticket */}
          <rect
            x={0.4}
            y={4.6}
            width={9}
            height={16}
            rx={1.2}
            transform="rotate(-13 1.4 4.6)"
            fill="#FFC400"
            stroke="#FFFFFF"
            strokeWidth={1.25}
          />

          {/* Front red ticket */}
          <rect
            x={8}
            y={3}
            width={9}
            height={16}
            rx={1.2}
            transform="rotate(8 8 3)"
            fill="#F51505"
            stroke="#FFFFFF"
            strokeWidth={1.25}
          />
        </>
      )}

      {ticketType === 'yellow' && (
        <rect
          x={5.5}
          y={3.5}
          width={9}
          height={16}
          rx={1.2}
          fill="#FFC400"
          stroke="#FFFFFF"
          strokeWidth={1.25}
        />
      )}

      {ticketType === 'red' && (
        <rect
          x={5.5}
          y={3.5}
          width={9}
          height={16}
          rx={1.2}
          fill="#F51505"
          stroke="#FFFFFF"
          strokeWidth={1.25}
        />
      )}
    </g>

    <defs>
      <filter
        id="ticketShadow"
        x={-3}
        y={-2}
        width={26}
        height={28}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={1.4} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
    </defs>
  </svg>
));
